import z from 'zod';
import {BaseIntegrationSchema} from './common';

export const SlackIntegrationSchema = BaseIntegrationSchema.extend({
  type: z.literal('slack'),
  webhookChannel: z.string().optional(),
  oauth: z.object({
    issuedAt: z.date(),
    accessToken: z.string(),
    scopes: z.string().array(),
    authedUserId: z.string(),
    team: z.object({
      id: z.string(),
      name: z.string(),
    }),

    // webhook channel is chosen during oauth. in order to change it, integration
    // must be re-auth'd
    webhook: z.object({
      channelId: z.string(),
      configurationUrl: z.string(),
      url: z.string(),
    }),
  }),
});

export type SlackIntegration = z.infer<typeof SlackIntegrationSchema>;
